import { useContext, useCallback, useState } from 'react';

import { formatListData, AjaxContext, UserContext, MerchantContext } from 'commons-ui';
import { IApp, IPageDetails, IPermissionSet } from '../../../../../models/settingsV2.model';
import { permissionSetUrlPrefix, RESOURCES, SETTINGS_V2_ACTION } from '../../../../../settingsV2Constant';
import { SERVICE_NAMES } from '../../../../../settingsV2Enum';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const { user } = useContext(UserContext);
	const [forceUpdate, setForceUpdate] = useState(false);
	const { merchantName } = useContext(MerchantContext);
	const turnForceUpdateOff = () => {
		setForceUpdate(false);
	};

	const requestCreatePermissionsSet = useCallback((appName: string, data: IPermissionSet) => {
		return postData({
			endpoint: `${permissionSetUrlPrefix}-createPermissionSet`,
			body: {
				...data,
				createdBy: user?.email,
				createdAt: Date.now(),
				userMerchant: merchantName,
				forwardReqRoute: `/dashboard/${RESOURCES.permissionSet}/${SETTINGS_V2_ACTION.createPermissionSet}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName
			}
		});
	}, []);

	const getPermissionsSetData = useCallback(async ({ app, pageDetails }: { app: IApp; pageDetails: IPageDetails }) => {
		const res = await postData({
			endpoint: `${permissionSetUrlPrefix}-getPermissionSets`,
			body: {
				pageNo: pageDetails.pageNo,
				pageSize: pageDetails.pageSize,
				userMerchant: merchantName,
				forwardReqRoute: `/dashboard/${RESOURCES.permissionSet}/${SETTINGS_V2_ACTION.getPermissionSets}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName: app.appName
			}
		});
		const listData: Array<IPermissionSet> = formatListData(res?.data?.data?.permissionSets);
		return { rowCount: res?.data?.data?.permissionSetsCount, data: listData };
	}, []);

	const requestUpdatePermissionsSet = useCallback((appName: string, data: IPermissionSet) => {
		return postData({
			endpoint: `${permissionSetUrlPrefix}-editPermissionSet`,
			body: {
				setId: data._id,
				permissionIds: data.permissionIds,
				forwardReqRoute: `/dashboard/${RESOURCES.permissionSet}/${SETTINGS_V2_ACTION.editPermissionSet}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName
			}
		});
	}, []);

	const requestDeletePermissionsSet = useCallback((appName: string, data: IPermissionSet) => {
		return postData({
			endpoint: `${permissionSetUrlPrefix}-deletePermissionSet`,
			body: {
				setId: data._id,
				forwardReqRoute: `/dashboard/${RESOURCES.permissionSet}/${SETTINGS_V2_ACTION.deletePermissionSet}`,
				forwardReqToService: SERVICE_NAMES.AUTH
			},
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		requestCreatePermissionsSet,
		getPermissionsSetData,
		requestUpdatePermissionsSet,
		requestDeletePermissionsSet,
		forceUpdate,
		setForceUpdate,
		turnForceUpdateOff
	};
};

export default useService;
